module.exports = __webpack_public_path__ + "static/media/contract-calculator.560bd501.svg";